module.exports = __webpack_public_path__ + "img/202308_05.39c06070.jpg";